<div class="dialog dialog--short">
  <app-base-header
    headerTitle="Plan Located"
    (closeClick)="close()"></app-base-header>
  <div class="dialog__content">
    <p>
      Protection plan
      <strong>{{ data.data.planInfo.consumerPlanName }}</strong>
      has been successfully located. It may take a few minutes to show up in the portal.
    </p>
    <p class="plan-register-success__description">
      To start a new claim related to this plan, click the Start New Claim button below.
    </p>
    <div class="inline-buttons inline-buttons--right">
      <button
        (click)="close()"
        class="inline-buttons__button _common-button--rounded"
        mat-flat-button
        color="primary">
        Ok
      </button>
      <button
        (click)="registerClaim()"
        class="inline-buttons__button _common-button--rounded"
        mat-flat-button
        color="primary">
        Start New Claim
      </button>
    </div>
  </div>
</div>
